import { functions as fn } from "firebase";

export const regenerateAllGameVersions = async (_: any, functions: fn.Functions) => {
  try {
    const getCall = functions.httpsCallable("regenerateAllGameVersions");
    return await getCall();
  } catch (error) {
    console.log("[regenerateAllGameVersions]: An error occured while clearing game specific collections", error);
    return {
        error: error.toString()
    };
  }
};